export default {
  buttons: {
    sign_in: 'Se connecter',
    sign_up: "S'inscrire",
    logout: 'Se déconnecter',
  },
  logout_confirm: {
    title: 'Se déconnecter ?',
    description: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    cancel: 'Annuler',
    confirm: 'Se déconnecter',
  },
};
